//import * as React from 'react';


export const idType = [

 "SINGAPORE CITIZEN",
 "SINGAPORE PERMANENT RESIDENT",
 "FOREIGNER (PASSPORT)"
];
export default idType




